import { useMutation, useQueryClient } from '@tanstack/react-query';

import PackagesService from '~/services/PackagesService';

import { inclusionsQueryKeys } from '../inclusions/inclusionsQueryKeys';
import {
  type PackageInclusionMutationPayload,
  savePackageInclusionChanges,
} from '../inclusions/packageInclusionMutationUtils';

import { offerQueryKeys } from './useGetOffer';

interface SaveOfferPackageParams {
  offerId: string;
  packageData: Record<string, unknown>;
  packageId: string;
  packageInclusionIdsToDelete?: Array<string>;
  packageInclusions: Array<PackageInclusionMutationPayload>;
}

export function useSaveOfferPackage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      offerId,
      packageData,
      packageId,
      packageInclusionIdsToDelete,
      packageInclusions,
    }: SaveOfferPackageParams) => {
      // Matches legacy PackageForm: inclusion and package saves are separate calls, so this is not atomic.
      await savePackageInclusionChanges({ offerId, packageInclusionIdsToDelete, packageInclusions });

      return PackagesService.updatePackage(packageData, offerId, packageId);
    },
    onSuccess: (_data, variables) =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: inclusionsQueryKeys.packageInclusionsByOffer(variables.offerId) }),
        queryClient.invalidateQueries({ queryKey: offerQueryKeys.detail(variables.offerId) }),
      ]),
  });
}
